"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var helper_1 = require("../helper");

var types_1 = require("../types");

var types_2 = require("./types");

function select(payload) {
  return helper_1.actionWrapper({
    payload: payload,
    group: types_1.Group.ResourcePicker,
    type: types_2.ActionType.SELECT
  });
}

exports.select = select;

function open(payload) {
  return helper_1.actionWrapper({
    payload: payload,
    group: types_1.Group.ResourcePicker,
    type: types_2.ActionType.OPEN
  });
}

exports.open = open;

function cancel(payload) {
  return helper_1.actionWrapper({
    payload: payload,
    group: types_1.Group.ResourcePicker,
    type: types_2.ActionType.CANCEL
  });
}

exports.cancel = cancel;

function close(payload) {
  return helper_1.actionWrapper({
    payload: payload,
    group: types_1.Group.ResourcePicker,
    type: types_2.ActionType.CANCEL
  });
}

exports.close = close;

function update(payload) {
  return helper_1.actionWrapper({
    payload: payload,
    group: types_1.Group.ResourcePicker,
    type: types_2.ActionType.UPDATE
  });
}

exports.update = update;

var ResourcePicker =
/** @class */
function (_super) {
  __extends(ResourcePicker, _super);

  function ResourcePicker(app, options, resourceType) {
    var _this = _super.call(this, app, types_1.Group.ResourcePicker, types_1.Group.ResourcePicker) || this;

    _this.selection = [];
    _this.resourceType = resourceType;

    _this.set(options, false);

    return _this;
  }

  Object.defineProperty(ResourcePicker.prototype, "payload", {
    get: function get() {
      return __assign({}, this.options, {
        id: this.id,
        resourceType: this.resourceType
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ResourcePicker.prototype, "options", {
    get: function get() {
      var options = {
        initialQuery: this.initialQuery,
        selectMultiple: this.selectMultiple,
        showHidden: this.showHidden,
        actionVerb: this.actionVerb
      };

      if (this.resourceType === types_2.ResourceType.Product) {
        var productOptions = __assign({}, options, {
          showVariants: this.showVariants
        });

        return productOptions;
      }

      return options;
    },
    enumerable: true,
    configurable: true
  });

  ResourcePicker.prototype.set = function (options, shouldUpdate) {
    if (shouldUpdate === void 0) {
      shouldUpdate = true;
    }

    var mergedOptions = helper_1.getMergedProps(this.options, options);
    var initialQuery = mergedOptions.initialQuery,
        _a = mergedOptions.showHidden,
        showHidden = _a === void 0 ? true : _a,
        _b = mergedOptions.showVariants,
        showVariants = _b === void 0 ? true : _b,
        _c = mergedOptions.selectMultiple,
        selectMultiple = _c === void 0 ? true : _c,
        _d = mergedOptions.actionVerb,
        actionVerb = _d === void 0 ? types_2.ActionVerb.Add : _d;
    this.initialQuery = initialQuery;
    this.showHidden = Boolean(showHidden);
    this.showVariants = Boolean(showVariants);
    this.selectMultiple = Boolean(selectMultiple);
    this.actionVerb = actionVerb;

    if (shouldUpdate) {
      this.update();
    }

    return this;
  };

  ResourcePicker.prototype.dispatch = function (action, selection) {
    if (action === types_2.Action.OPEN) {
      this.open();
    } else if (action === types_2.Action.UPDATE) {
      this.update();
    } else if (action === types_2.Action.CLOSE || action === types_2.Action.CANCEL) {
      this.cancel();
    } else if (action === types_2.Action.SELECT) {
      this.selection = selection;
      this.app.dispatch(select({
        id: this.id,
        selection: this.selection
      }));
    }

    return this;
  };

  ResourcePicker.prototype.update = function () {
    this.app.dispatch(update(this.payload));
  };

  ResourcePicker.prototype.open = function () {
    this.app.dispatch(open(this.payload));
  };

  ResourcePicker.prototype.cancel = function () {
    this.app.dispatch(cancel({
      id: this.id
    }));
  };

  ResourcePicker.prototype.close = function () {
    this.cancel();
  };

  return ResourcePicker;
}(helper_1.ActionSet);

exports.ResourcePicker = ResourcePicker;

exports.create = function (app, baseOptions) {
  var resourceType = baseOptions.resourceType,
      _a = baseOptions.options,
      options = _a === void 0 ? {} : _a;
  return new ResourcePicker(app, options, resourceType);
};